import { Actions, ActionTypes } from './actions';
import { Account, Client, Grant } from '../../types/management-auth';
import { getItem } from '../../helpers/localStorage';

export interface State {
    isLoading: boolean;
    isLoadingAccount: boolean;
    isLoadingClients: boolean;
    account: Account | undefined;
    continueWhilePending: boolean;
    clients: Client[];
    grantsByClientId: { [client_id: string]: Grant[] };
}

export const initialState: State = {
    isLoading: false,
    isLoadingAccount: false,
    isLoadingClients: false,
    account: undefined,
    continueWhilePending: false,
    clients: [],
    grantsByClientId: {},
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetAccount:
            return {
                ...initialState,
                isLoading: true,
                isLoadingAccount: true,
                isLoadingClients: true,
                continueWhilePending:
                    getItem(
                        `checkout_wizard_continue_while_pending_${action.payload.accountId.substr(1)}`
                    ) === 'true',
            };

        case ActionTypes.FetchAccountResponse:
            return {
                ...state,
                isLoadingAccount: false,
                account: action.payload.account,
                isLoading: state.isLoadingClients,
            };

        case ActionTypes.FetchClientsResponse:
            return {
                ...state,
                clients: action.payload.clients,
                grantsByClientId: action.payload.grants,
                isLoadingClients: false,
                isLoading: state.isLoadingAccount,
            };

        case ActionTypes.ContinueWhilePending:
            return {
                ...state,
                continueWhilePending: true,
            };

        default:
            return state;
    }
}
